import * as React from 'react';
import cx from 'classnames';
import { teamsIconClassNames } from '../teamsIconClassNames';
export default {
  icon: function icon(_ref) {
    var classes = _ref.classes;
    return React.createElement("svg", {
      role: "presentation",
      focusable: "false",
      viewBox: "8 8 16 16",
      className: classes.svg
    }, React.createElement("g", {
      className: cx(teamsIconClassNames.filled, classes.filledPart)
    }, React.createElement("circle", {
      cx: "22",
      cy: "16",
      r: "2"
    }), React.createElement("circle", {
      cx: "16",
      cy: "16",
      r: "2"
    }), React.createElement("circle", {
      cx: "10",
      cy: "16",
      r: "2"
    })), React.createElement("g", {
      className: cx(teamsIconClassNames.outline, classes.outlinePart)
    }, React.createElement("circle", {
      cx: "22",
      cy: "16",
      r: "1.5"
    }), React.createElement("circle", {
      cx: "16",
      cy: "16",
      r: "1.5"
    }), React.createElement("circle", {
      cx: "10",
      cy: "16",
      r: "1.5"
    })));
  },
  styles: {}
};